import { jsx as _jsx } from "react/jsx-runtime";
import { TableCell } from '@/core/ui';
import { forwardRef } from 'react';
const quantityChipTableCellWidth = 68;
const deletableQuantityChipTableCellWidth = 80;
/**
 * Used to prevent a table cell width changing in case there are no chips shown in a column that was colspan'ned.
 *
 * Fixed cell width is used because there is a case when column header width cannot be set: for example, the column
 * has colSpan={N}.
 */
const QuantityChipTableCell = forwardRef(({ deletable, ...props }, ref) => {
    const width = deletable ? deletableQuantityChipTableCellWidth : quantityChipTableCellWidth;
    return (_jsx(TableCell, { ...props, ref: ref, 
        // Should be centered since chips can have different width
        align: "center", width: width }));
});
export { QuantityChipTableCell };
